import { render, staticRenderFns } from "./krasImpr.vue?vue&type=template&id=7156613e"
import script from "./krasImpr.vue?vue&type=script&lang=js"
export * from "./krasImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7156613e')) {
      api.createRecord('7156613e', component.options)
    } else {
      api.reload('7156613e', component.options)
    }
    module.hot.accept("./krasImpr.vue?vue&type=template&id=7156613e", function () {
      api.rerender('7156613e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/risk/krasImpr.vue"
export default component.exports